import { render } from "./TokenAndFirmSelectionComponent.vue?vue&type=template&id=1c06206a&scoped=true"
import script from "./TokenAndFirmSelectionComponent.vue?vue&type=script&lang=js"
export * from "./TokenAndFirmSelectionComponent.vue?vue&type=script&lang=js"

import "./TokenAndFirmSelectionComponent.vue?vue&type=style&index=0&id=1c06206a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c06206a"]])

export default __exports__